import apiClient from './client';

export interface TrainerRow {
  id: number;
  name: string;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  state?: string | null;
  trainingMap?: string | null;
  isActive?: boolean;
}

export interface CoachRow {
  id: number;
  name: string;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  state?: string | null;
  coachingMap?: string | null;
  isActive?: boolean;
}

export interface ChurchDirectoryRow {
  id: number;
  churchName: string;
  city?: string | null;
  state?: string | null;
  denomination?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
}

export const listTrainers = async (): Promise<{ success: boolean; data: TrainerRow[] }> => {
  const response = await apiClient.get('/trainers', { params: { limit: 200 } });
  return response.data;
};

export const listCoaches = async (): Promise<{ success: boolean; data: CoachRow[] }> => {
  const response = await apiClient.get('/coaches', { params: { limit: 200 } });
  return response.data;
};

export const listChurches = async (): Promise<{ success: boolean; data: ChurchDirectoryRow[] }> => {
  const response = await apiClient.get('/church-directory', { params: { limit: 200 } });
  return response.data;
};
